import { FC } from 'react';
import { SubmitButton } from '@/components/form/submit-button';
import { strings } from '@/constants/strings';
import { useForm } from '@/forms/hooks/use-form';
import { CreateCredentialFieldValues } from '@/forms/schemas/create-credential/field-values';
import { buildCreateCredentialFormSchema } from '@/forms/schemas/create-credential/schema';
import { DrawerContentFormLayout } from '@/layouts/drawer-content-form-layout';

export type CreateCredentialFormProps = {
  onSubmit: (values: CreateCredentialFieldValues) => void;
};

export const CreateCredentialForm: FC<CreateCredentialFormProps> = ({
  onSubmit,
}) => {
  const formSchema = buildCreateCredentialFormSchema();

  const { fieldItems, handleSubmit } = useForm({
    schema: formSchema,
    onSubmit,
  });

  return (
    <DrawerContentFormLayout
      buttonItems={[
        <SubmitButton
          key="submit"
          text={strings.devices.drawer_assign.submit}
        />,
      ]}
      fieldItems={fieldItems}
      onSubmit={handleSubmit}
    />
  );
};
